<template>
    <div>
        <ContactDetailsComponent />
    </div>
</template>
  
<script>
import ContactDetailsComponent from '@/components/ContactDetailsComponent.vue';

export default {
    components: {
        ContactDetailsComponent
},
};
</script>